import styled from 'styled-components';

import { BASE } from 'design-system/variables/spacing';

const Divider = styled.hr<{ full?: boolean }>`
  border-top: 1px solid ${({ theme }) => theme.color.border.primary};
  margin: ${BASE * 2.5}px ${({ full }) => (full ? 0 : BASE * 2.5)}px;
`;

export default Divider;
